import styled from 'styled-components'

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  overflow: hidden;
`

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`

export const ListActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  > div {
    display: flex;
    gap: 3px;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`

export const ListContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`

export const ListView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const GridView = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, 1fr);
  gap: 12px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  text-align: center;

  h3 {
    margin: 12px 0 6px;
    font-size: ${({ theme }) => theme.typography.fontSize.title};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  p {
    margin: 0 0 20px;
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    color: ${({ theme }) => theme.colors.text.secondary};
    max-width: 320px;
  }
`

export const ListFooter = styled.div`
  padding: 12px 16px;
  background: white;
  border-top: 1px solid ${({ theme }) => theme.colors.border.default};
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > span {
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  > div {
    display: flex;
    align-items: center;
    gap: 6px;

    > span {
      padding: 0 10px;
      font-size: ${({ theme }) => theme.typography.fontSize.small};
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`

export const BulkActionsBar = styled.div`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.lg};
  z-index: 100;
  animation: slideUp 0.3s ease-out;

  > span {
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  > div {
    display: flex;
    gap: 6px;
  }

  @keyframes slideUp {
    from {
      transform: translateX(-50%) translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    left: 10px;
    right: 10px;
    transform: none;
    width: calc(100% - 20px);

    @keyframes slideUp {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }
  }
`

export const FilterChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 16px;
  background: ${({ theme }) => theme.colors.background.secondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};

  > div {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 8px;
    background: white;
    border: 1px solid ${({ theme }) => theme.colors.border.default};
    border-radius: ${({ theme }) => theme.borderRadius.small};
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    color: ${({ theme }) => theme.colors.text.primary};

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 13px;
      height: 13px;
      padding: 0;
      background: transparent;
      border: none;
      cursor: pointer;

      svg {
        width: 10px;
        height: 10px;
        color: ${({ theme }) => theme.colors.text.secondary};
      }

      &:hover svg {
        color: ${({ theme }) => theme.colors.text.primary};
      }
    }
  }
`
